import React from 'react';
import { Box, Button } from '@mui/material';

interface BulkUpdateActionsProps {
  activeStep: number;
  steps: string[];
  onBack: () => void;
  onNext: () => void;
  onReset: () => void;
  isSubmitting: boolean;
  selectedStores: any[];
  bulkUpdateMode?: 'manual' | 'bulk-upload';
  selectedAction?: 'review' | 'update';
}

const BulkUpdateActions: React.FC<BulkUpdateActionsProps> = ({
  activeStep,
  steps,
  onBack,
  onNext,
  onReset,
  isSubmitting,
  selectedStores,
  bulkUpdateMode = 'manual',
  selectedAction = 'update',
}) => {
  // Don't show actions for bulk upload mode - it has its own internal navigation
  if (bulkUpdateMode === 'bulk-upload') {
    return null;
  }

  const isStepValid = () => {
    if (activeStep === 0) {
      // For manual mode, we require stores to be selected at step 0
      return selectedStores.length > 0;
    }
    return true;
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
      <Button disabled={activeStep === 0} onClick={onBack} data-testid='manualEditBackButton'>
        Back
      </Button>
      <Box>
        {selectedAction === 'review' && activeStep === 1 ? (
          <Button variant='outlined' onClick={onReset} data-testid='manualEditResetButton'>
            Reset
          </Button>
        ) : activeStep < steps.length - 1 ? (
          <>
            <Button
              variant="contained"
              onClick={onNext}
              disabled={!isStepValid() || isSubmitting}
              data-testid='manualEditNextButton'
            >
              {selectedAction === 'update' && activeStep === 1 ? 'Publish' : 'Next'}
            </Button>
            <Button variant='outlined' onClick={onReset} sx={{ ml: 1 }} data-testid='manualEditResetButton'>
              Reset
            </Button>
          </>
        ) : (
          <Button variant='outlined' onClick={onReset} data-testid='manualEditResetButton'>
            Reset
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BulkUpdateActions; 